import {
  FETCH_AUDIT_LOGS_REQUEST,
  FETCH_AUDIT_LOGS_SUCCESS,
  FETCH_AUDIT_LOGS_FAILURE,
  SEARCH_AUDIT_LOGS_REQUEST,
  SEARCH_AUDIT_LOGS_SUCCESS,
  SEARCH_AUDIT_LOGS_FAILURE
} from "redux/constants/AuditLogs";



export const fetchAuditLogs = (startDate, endDate) => ({
  type: FETCH_AUDIT_LOGS_REQUEST,
  payload: { startDate, endDate },
});

export function fetchAuditLogsSuccess(data) {
  return {
    type: FETCH_AUDIT_LOGS_SUCCESS,
    payload: data,
  };
}

export function fetchAuditLogsFailure(error) {
  return {
    type: FETCH_AUDIT_LOGS_FAILURE,
    payload: error,
  };
}


export const searchAuditLogs = (startDate, endDate, searchKeyword) => ({
  type: SEARCH_AUDIT_LOGS_REQUEST,
  payload: { startDate, endDate, searchKeyword },
});

export function searchAuditLogsSuccess(data) {
  return {
    type: SEARCH_AUDIT_LOGS_SUCCESS,
    payload: data,
  };
}

export function searchAuditLogsFailure(error) {
  return {
    type: SEARCH_AUDIT_LOGS_FAILURE,
    payload: error,
  };
}
